import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {PaymentGatewayWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/paymentGatewayWorkspaceCapability/domain/PaymentGatewayWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type PaymentGatewayWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.paymentGateway> & {
    fixedUdoTemplates: {
        [PaymentGatewayWorkspaceCapabilityUdoTemplateKey.paymentSession]: {
            udoAdditionalColumnIds: {
                amount: Uuid;
                currency: Uuid;
                expiresAt: Uuid;
                failureRedirectUrl: Uuid;
                gatewayMode: Uuid;
                gatewayProvider: Uuid;
                gatewayResponse: Uuid;
                idempotencyKey: Uuid;
                pspTransactionId: Uuid;
                redirectUrl: Uuid;
                referenceId: Uuid;
                referenceType: Uuid;
                status: Uuid;
                successRedirectUrl: Uuid;
            };
        };
        [PaymentGatewayWorkspaceCapabilityUdoTemplateKey.webhookEvent]: {
            udoAdditionalColumnIds: {
                errorMessage: Uuid;
                gatewayProvider: Uuid;
                payload: Uuid;
                paymentSessionId: Uuid;
                processingStatus: Uuid;
                pspEventId: Uuid;
                receivedAt: Uuid;
                status: Uuid;
            };
        };
    };
};

export const paymentGatewayWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [PaymentGatewayWorkspaceCapabilityUdoTemplateKey.paymentSession]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                referenceType: uuidZodValidator,
                referenceId: uuidZodValidator,
                gatewayProvider: uuidZodValidator,
                gatewayMode: uuidZodValidator,
                amount: uuidZodValidator,
                currency: uuidZodValidator,
                pspTransactionId: uuidZodValidator,
                redirectUrl: uuidZodValidator,
                successRedirectUrl: uuidZodValidator,
                failureRedirectUrl: uuidZodValidator,
                gatewayResponse: uuidZodValidator,
                idempotencyKey: uuidZodValidator,
                expiresAt: uuidZodValidator,
            }),
        }),
        [PaymentGatewayWorkspaceCapabilityUdoTemplateKey.webhookEvent]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                paymentSessionId: uuidZodValidator,
                gatewayProvider: uuidZodValidator,
                pspEventId: uuidZodValidator,
                payload: uuidZodValidator,
                processingStatus: uuidZodValidator,
                errorMessage: uuidZodValidator,
                receivedAt: uuidZodValidator,
            }),
        }),
    }),
}) satisfies zod.ZodType<PaymentGatewayWorkspaceCapabilityUdoBindings>;
